<ng-container *transloco="let t;">
<app-list-view [title]="t('common.labels.onlinetest_partner')" [messages]="messages" [loading]="loading">

  <div buttons>
    <button withRight="admin.partner.list" pButton (click)="onReload()" type="button" icon="pi pi-refresh" class="p-button-secondary p-button-outlined p-mb-2" aria-label="{{ t('common.labels.reload_list') }}" pTooltip="{{ t('common.labels.reload_list') }}" tooltipPosition="left"></button>
  </div>

  <div table>
    <p-table
      [value]="partners"
      [paginator]="true"
      [rows]="20"
      stateStorage="local"
      stateKey="partner-list"
      [rowsPerPageOptions]="rowsPerPage"
      [showCurrentPageReport]="true"
      [currentPageReportTemplate]="t('common.labels.current_page_report')"
    >
      <ng-template pTemplate="colgroup">
        <colgroup>
          <col>
          <col>
        </colgroup>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="name" aria-label="{{ t('common.labels.name') }}">{{ t('common.labels.name') }}
            <p-sortIcon field="name"></p-sortIcon>
          </th>
          <th class="p-text-right" aria-label="{{ t('common.labels.onlinetests') }}">{{ t('common.labels.onlinetests') }} ({{ t('common.labels.active') }})</th>
          <th class="p-text-right" aria-label="{{ t('common.labels.api') }}">{{ t('common.labels.api') }}</th>
        </tr>
    </ng-template>
      <ng-template pTemplate="body" let-partner>
        <tr (click)="onOpen(partner)" (keyup.enter)="onOpen(partner)" hoverOnRight="admin.partner.show" tabindex="0">
          <td>{{ partner.name }}</td>
          <td class="p-text-right">{{ partner.onlinetests.length }} ({{ partner.active_onlinetests }})</td>
          <td class="p-text-right" [innerHTML]="partner.has_api | isChecked"></td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td class="no-data" colspan="3">{{ t('common.labels.no_data') }}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>

</app-list-view>
</ng-container>
